import { render, staticRenderFns } from "./assistance-cross-selling.component.vue?vue&type=template&id=53eef158&"
import script from "./assistance-cross-selling.component.vue?vue&type=script&lang=ts&"
export * from "./assistance-cross-selling.component.vue?vue&type=script&lang=ts&"
import style0 from "./assistance-cross-selling.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assistance-cross-selling.component.vue"
export default component.exports